<template>
	<div class="main upload">
		<div class="table-form">
			<div class="form-title">上传内容</div>
			<form action="javascript:void(0)" method="post">
				<label>内容名称:</label>
				<input type="text" class="filename" name="filename" v-model="filename" value="" placeholder="填写内容名称" maxlength="50" />
				<!--<div class="tipCommon"></div>-->
				<label>查看权限:</label>
				<div class="rightsOper clear-fix">
					<div class="rightsLeft">
						<Dropdown ref="child"  :data="qgroup" multiple grouped :width="282" :cbItemChanged="changed2" :cbCustomSelectedText="qgroupSelectedText" :placeholder="'选择可查看的分组'"></Dropdown>
					</div>
					<div class="rightsRight">
						<Dropdown ref="child" :data="quser" multiple grouped :width="282" :cbItemChanged="changed2" :cbCustomSelectedText="quserSelectedText" :placeholder="'选择可查看的人'"></Dropdown>
					</div>
				</div>
				<label>编辑权限:</label>
				<div class="rightsOper clear-fix">
					<div class="rightsLeft">
						<Dropdown ref="child" :data="egroup" multiple grouped :width="282" :cbItemChanged="changed2" :cbCustomSelectedText="egroupSelectedText" :placeholder="'选择可编辑的分组'"></Dropdown>
					</div>
					<div class="rightsRight">
						<Dropdown ref="child" :data="euser" multiple grouped :width="282" :cbItemChanged="changed2" :cbCustomSelectedText="euserSelectedText" :placeholder="'选择可编辑的人'"></Dropdown>
					</div>

				</div>

				<label>说明:</label>
				<textarea :class="['instruction',(instrInput==true)?'act':'']" @click="instrInputFun" name="instruction" v-model="instruction" placeholder="输入内容介绍" maxlength="300"></textarea>
				<label>文件:</label>
				<div>
					<ul class="list_group" v-for="(item,index) in uploaditems">
						<li class="list_group_item clear-fix">
							<input type="text" disabled="" class="item-text" placeholder="输入附件地址" :value="item.text" />
							<div class="btn_group">
								<a class="upload_btn" href="javascript:void(0)">
									<input @change="fileChange($event,index,uploaditems)" type="file" name="files[]">
								</a>
								<!--<a class="edit_btn" href="javascript:void(0)">
									
								</a>-->
								<a class="delete_btn last" @click="deleteItem(index,uploaditems)" href="javascript:void(0)"></a>
							</div>
						</li>
					</ul>
					<div class="newAdd" @click="addItem(uploaditems)" v-if="uploaditems.length<10">+新增</div>
				</div>
				<label>地址:</label>
				<div>
					<ul class="list_group" v-for="(item,index) in addressitems">
						<li class="list_group_item clear-fix">
							<input type="text" class="item-text" placeholder="输入链接地址" v-model="item.text" />
							<div class="btn_group">
								<!--<a class="edit_btn" href="javascript:void(0)">
									
								</a>-->
								<a class="delete_btn last" @click="deleteItem(index,addressitems)" href="javascript:void(0)"></a>
							</div>
						</li>
					</ul>
					<div class="newAdd" @click="addItem(addressitems,'http://')" v-if="addressitems.length<10">+新增</div>
				</div>
				<label>关联:</label>
				<select class="form-control " id="connect" multiple="multiple">
					<!--<option value="AL" v-for="itemId in connect" :value="itemId">{{itemId}}</option>-->
				</select>
				<label>标签:</label>
				<select class="form-control " id="tags" multiple="multiple"> </select>
				<div class="formBtn-group">
					<div class="cancel" @click="goBack">取消</div>
					<input type="submit" name="submitBtn" id="submitBtn" @click="contentAdd" value="提交" />
				</div>
			</form>
		</div>
		<div class = "login-copyright" > © 2018 zhiyun-tech.com All rights reserved.   桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
	</div>
</template>

<script>
	import Dropdown from '@/components/Dropdown'
	import checkBox from '@/components/checkBox'
	export default {
		name: 'contentEdit',
		data() {
			return {
				qgroup: [{
					label: "",
					children: {}
				}],
				quser: [{
					label: "",
					children: {}
				}],
				egroup: [{
					label: "",
					children: {}
				}],
				euser: [{
					label: "",
					children: {}
				}],
				uploaditems: [{
					text: ''
				}],
				addressitems: [{
					text: 'http://'
				}],
				selectNode: {
					qgroup: "",
					quser: "",
					egroup: "",
					euser: ""
				},
				connect: [],
				tags: "",
				filename: "",
				instruction: "",
				instrInput: false
			}
		},
		components: {
			Dropdown,
			checkBox
		},
		created: function() {
			this.$nextTick(() => {
				$("#tags").select2({
					tags: true,
					maximumSelectionLength: 5,
					tokenSeparators: ['&&'],
					placeholder: "最多添加5个标签，每个标签10个字，回车添加一个标签",
					maximumInputLength: 10
				}).val();
				this.common.get('group/showAllGroup', this.getGroup,{},false);
				this.common.get('content/getAllContentId', this.getContentId,{},false);
				
				if(this.$route.query.id) {
					this.common.get('user/showAllUserNotContentSelf?id=' + this.getLocalUser.id+"&&contentId="+this.$route.query.id, this.getUser,{},false);
					this.common.get('content/queryById?id=' + this.$route.query.id, this.editCreate,{},false);
				} else{
					this.common.get('user/showAllUserNotContentSelf?id=' + this.getLocalUser.id, this.getUser,{},false);
				}
			})
		},
		methods: {
			editCreate: function(data) {
				if(data != null) {
					this.filename = data.contentInfo[0].contentname;
					this.instruction = data.contentInfo[0].remark;
					this.qgroup[0].children = this.$refs.child.setData(this.qgroup[0].children, data.observeGroupIds, true)
					this.quser[0].children = this.$refs.child.setData(this.quser[0].children, data.observeUserIds, true)
					this.egroup[0].children = this.$refs.child.setData(this.egroup[0].children, data.editGroupIds, true)
					this.euser[0].children = this.$refs.child.setData(this.euser[0].children, data.editUserIds, true)
					this.uploaditems = this.getArrToJson(data.files.sourceUrls)
					this.addressitems = this.getArrToJson(data.files.addresses)
					$('#connect').select2({
						tags: true,
						tokenSeparators: [','],
						placeholder: "输入关联"
					}).val(data.files.connects).trigger('change');
					$("#tags").select2({
						tags: data.tags,
						maximumSelectionLength: 5,
						tokenSeparators: ['&&'],
						placeholder: "最多添加5个标签，每个标签10个字，回车添加一个标签",
						maximumInputLength: 10
					}).val(data.tags).trigger('change');
				}
			},
			getGroup: function(data) {
				this.qgroup = this.$refs.child.renderData("groupname", data, "分组");
				this.egroup = this.$refs.child.renderData("groupname", data, "分组");
			},
			getUser: function(data) {
				this.quser = this.$refs.child.renderData("nickname", data, "组员");
				this.euser = this.$refs.child.renderData("nickname", data, "组员");
			},
			getContentId: function(data) {
				this.connect = data;
				 $('#connect').select2({
	                data: data,
	                tags: true,
	                tokenSeparators: [','],
	                placeholder: "添加标签"
	            }).val();
				//				this.quser = this.$refs.child.renderData("username",data,"组员");
			},
			instrInputFun: function() {
				this.instrInput = !this.instrInput;
			},
			goBack: function() {
				location.href = "/contentList"
			},
			addItem: function(items,str) {
				items.push({
					text: str
				});
			},
			deleteItem: function(index, items) {
				if(items.length > 1) {
					items.splice(index, 1)
				}
			},
			upload: function(file, index, items) {
				var filename = file.name;
				var storeAs = this.common.pathJoin(['/' + this.common.OSSConfig.rootDir, 'binary', parseInt(Math.random()*10000), filename]);
				this.common.ossupload(file, storeAs, (result) => {
					var url = 'https://' + this.common.OSSConfig.bucket + '.' + this.common.OSSConfig.endpoint + result.name;
					this.uploaditems[index].text = url
				})
			},
			fileChange: function($event, index) {
				var self = $event.currentTarget;
				var file = $event.currentTarget.files[0];
				this.upload(file, index)
			},
			getArrToJson: function(arr) {
				let Json = [];
				if(arr.length > 0) {
					arr.forEach(function(k, index) {
						Json.push({
							text: k
						})
					})
				} else {
					Json = [{
						text: ""
					}]
				}

				return Json;
			},
			getitems: function(items, tip) {
				let arr = []
				items.forEach(function(k) {
					if(k.text != "") {
						arr.push(k.text)
					}
				})
				if(arr.length == 0) {
					return arr;
				} else {
					return arr.join(tip);
				}
			},
			contentAdd: function() {
				let params = {}
				let _this = this;
				if(!this.$route.query.id) {
					params.publisher = this.getLocalUser.id
				} else {
					params.id = this.$route.query.id
				}
				params.contentName = this.filename;
				params.observeGroupIds = this.selectNode.qgroup
				params.observeUserIds = this.selectNode.quser
				params.editGroupIds = this.selectNode.egroup
				params.editUserIds = this.selectNode.euser
				params.remark = this.instruction
				params.tags = $("#tags").val().join("&&");
				params.sourceUrls = this.getitems(this.uploaditems, ",")
				params.address = (this.getitems(this.addressitems, ",").length==0)?"":this.getitems(this.addressitems, ",")
				params.connectIds = $("#connect").val().join("&&");
				let sourceUrlslength = (params.sourceUrls == "") ? 0 : params.sourceUrls.split(",").length;
				let addresslength = (params.address == "") ? 0 : params.address.split(",").length;
				let countAll = sourceUrlslength + addresslength + $("#connect").val().length
				console.log(params)
				if(this.filename == "") {
					return this.layer.alert("内容名称必须填写");
				}
				if(!this.$route.query.id) {
					let validateContentname = true;
					this.common.get('content/validateContentName', function(res){
						if(res.errcode != 0) {
							_this.layer.alert(res.errmsg);
							validateContentname = false;
						}
					}, {contentName: this.filename}, false);
					if(validateContentname == false) {
						return false;
					}
				}
				if(this.getitems(this.uploaditems, ",") == "" && this.getitems(this.addressitems, ",") == "" && $("#connect").val().join("&&") == "") {
					return this.layer.alert("至少上传一个附件地址或者关联");
				}
				if(countAll > 9) {
					return this.layer.alert("附件地址或者关联总共不得超过9个");
				}
				if($("#tags").val().join("&&") == "") {
					return this.layer.alert("至少弄一个标签");
				}
				if(!this.$route.query.id) {
					this.common.post('content/addContent', this.contentAddResult, params, false);
				} else {
					this.common.post('content/editContent', this.contentAddResult, params, false);
				}

			},
			contentAddResult: function(data) {
				this.layer.alert("成功", function() {
					location.href = "/contentList"
				})
			},
			changed2(item) {
				if(item.label !== 'All') return
				let copy = JSON.parse(JSON.stringify(data1))
				copy.forEach(d => !d.disabled && (d.selected = item.selected))
				this.data1 = copy
			},
			qgroupSelectedText(selected, defaultFn) {
				this.selectNode.qgroup = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			},
			quserSelectedText(selected, defaultFn) {
				this.selectNode.quser = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			},
			egroupSelectedText(selected, defaultFn) {
				this.selectNode.egroup = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			},
			euserSelectedText(selected, defaultFn) {
				this.selectNode.euser = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			}
		}

	}
</script>

<style>
	@import url("../../static/bower_components/Font-Awesome/css/font-awesome.css");
	@import url("../../static/css/editForm.css");
</style>


// WEBPACK FOOTER //
// src/assets/contentEdit.vue